/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs */

const en_admin_questionnaire_editor_welcome_state_description = /** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know your community better by adding questions to your signup form. New members will be prompted to answer them when they join your space.`)
};

const nl_admin_questionnaire_editor_welcome_state_description = /** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer je community beter kennen door vragen toe te voegen aan je registratieformulier. Nieuwe leden worden gevraagd deze te beantwoorden wanneer ze lid worden van je Space.`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */
const de_admin_questionnaire_editor_welcome_state_description = en_admin_questionnaire_editor_welcome_state_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */
const es_admin_questionnaire_editor_welcome_state_description = en_admin_questionnaire_editor_welcome_state_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_welcome_state_description = en_admin_questionnaire_editor_welcome_state_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */
const it_admin_questionnaire_editor_welcome_state_description = en_admin_questionnaire_editor_welcome_state_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_welcome_state_description = en_admin_questionnaire_editor_welcome_state_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_welcome_state_description = en_admin_questionnaire_editor_welcome_state_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_welcome_state_description = en_admin_questionnaire_editor_welcome_state_description;

/** @type {(inputs: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_welcome_state_description = en_admin_questionnaire_editor_welcome_state_description;

/**
* | output |
* | --- |
* | "Get to know your community better by adding questions to your signup form. New members will be prompted to answer them when they join your space." |
*
* @param {Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_welcome_state_description = /** @type {((inputs?: Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Welcome_State_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_welcome_state_description(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_welcome_state_description(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_welcome_state_description(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_welcome_state_description(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_welcome_state_description(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_welcome_state_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_welcome_state_description(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_welcome_state_description(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_welcome_state_description(inputs)
	return ro_admin_questionnaire_editor_welcome_state_description(inputs)
});
export { admin_questionnaire_editor_welcome_state_description as "admin.questionnaire_editor.welcome_state_description" }